class YaMetrika {

    static metrikaId = 53957554;

    static oneClickBuyGoalId = 'one_click_buy';
    static productViewGoalId = 'Product_view';
    static addToCartGoalId = 'Add_to_cart';
    static cartViwedGoalId = 'cart_viwe';
    static beginCheckoutGoalId = 'begin_checkout';
    static orderGoalId = 'Order';

    static deleteBasketGoalId = 'delet_cart';

    static loginGoalId = 'login';
    static downloadGoalId = 'download';
    static contactViweGoalId = 'contact_viwe';
    static regGuaranteeGoalId = 'reg_guarantee';


    static init() {
        this.downloadInit();
    }

    static checkYmExists() {
        if(!!window.ym) return true;

        return false;
    }

    static downloadInit() {
        const downloadLinks = document.querySelectorAll('[data-metrika-download]');

        const self = this;

        downloadLinks.forEach(function (link) {
            link.addEventListener('click', function (event) {
                ym(self.metrikaId, 'reachGoal' , self.downloadGoalId);
            });
        });
    }

    static oneClickBuyTrigger() {

        if(!this.checkYmExists()) return false;

        ym(this.metrikaId, 'reachGoal' , this.oneClickBuyGoalId);
    }

    static deleteBasketTrigger() {

        if(!this.checkYmExists()) return false;

        ym(this.metrikaId, 'reachGoal' , this.deleteBasketGoalId);
    }

    static productViewTrigger(documentReady = false) {
        if(!this.checkYmExists()) return false;
        ym(this.metrikaId, 'reachGoal' , this.productViewGoalId);
    }

    static productViewTriggerDocReady() {
        const self = this;
        document.addEventListener('DOMContentLoaded', () => {
            self.productViewTrigger();
        })
    }

    static cartViwedTrigger (documentReady = false) {
        if(!this.checkYmExists()) return false;
        ym(this.metrikaId, 'reachGoal' , this.cartViwedGoalId);
    }

    static cartViwedTriggerDocReady () {
        const self = this;
        document.addEventListener('DOMContentLoaded', () => {
            self.cartViwedTrigger();
        })
    }


    static beginCheckoutTrigger (documentReady = false) {
        if(!this.checkYmExists()) return false;
        ym(this.metrikaId, 'reachGoal' , this.beginCheckoutGoalId);
    }

    static beginCheckoutTriggerDocReady () {
        const self = this;
        document.addEventListener('DOMContentLoaded', () => {
            self.beginCheckoutTrigger();
        })
    }


    static loginTrigger() {
        if(!this.checkYmExists()) return false;

        ym(this.metrikaId, 'reachGoal' , this.loginGoalId);
    }

    static contactViwedTrigger (documentReady = false) {
        if(!this.checkYmExists()) return false;
        ym(this.metrikaId, 'reachGoal' , this.contactViweGoalId);
    }

    static contactViwedTriggerDocReady () {
        const self = this;
        document.addEventListener('DOMContentLoaded', () => {
            self.contactViwedTrigger();
        })
    }

    static orderTrigger() {
        if(!this.checkYmExists()) return false;

        ym(this.metrikaId, 'reachGoal' , this.orderGoalId);
    }

    static orderTriggerDocReady () {
        const self = this;
        document.addEventListener('DOMContentLoaded', () => {
            self.orderTrigger();
        })
    }

    static regGuaranteeTrigger() {
        if(!this.checkYmExists()) return false;

        ym(this.metrikaId, 'reachGoal' , this.regGuaranteeGoalId);
    }


    static addToCartTrigger() {
        if(!this.checkYmExists()) return false;

        ym(this.metrikaId, 'reachGoal' , this.addToCartGoalId);
    }
}